import React, { Component } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import requester from "../../lib/requester";
import _ from "lodash";
import { UserOutlined } from '@ant-design/icons'
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curTime: "",
      user: JSON.parse(window.localStorage.getItem("is_user")) || {},
      sidebarRoutes: [],
    };
  }

  componentDidMount() {
    this.getSideBarRoutes();
    var menu = $(".sidebar-menu"),
      subMenuSelector = ".sidebar-submenu",
      animationSpeed = 300;
    $(menu).on("click", "li a", function (e) {
      var $this = $(this);
      var checkElement = $this.next();

      if (checkElement.is(subMenuSelector) && checkElement.is(":visible")) {
        checkElement.slideUp(animationSpeed, function () {
          checkElement.removeClass("menu-open");
        });
        checkElement.parent("li").removeClass("active");
      }

      //If the menu is not visible
      else if (
        checkElement.is(subMenuSelector) &&
        !checkElement.is(":visible")
      ) {
        //Get the parent menu
        var parent = $this.parents("ul").first();
        //Close all open menus within the parent
        var ul = parent.find("ul:visible").slideUp(animationSpeed);
        //Remove the menu-open class from the parent
        ul.removeClass("menu-open");
        //Get the parent li
        var parent_li = $this.parent("li");

        //Open the target menu and add the menu-open class
        checkElement.slideDown(animationSpeed, function () {
          //Add the class active to the parent li
          checkElement.addClass("menu-open");
          parent.find("li.active").removeClass("active");
          parent_li.addClass("active");
        });
      }
      //if this isn't a link, prevent the page from being redirected
      if (checkElement.is(subMenuSelector)) {
        e.preventDefault();
      }
    });
  }

  getSideBarRoutes = () => {
    requester.getArman(
      "/arman/v1/general/menu?userId=" + this.state.user.user_id,
      {
        success: function (response) {
          let data = response.data.data;
          let container = [];
          let { user } = this.state;
          let sso_token = user.sso_token;

          // Level 1
          data.forEach((item, index) => {
            if (item.is_group === "Y") {
              container.push({
                menu_id: item.menu_id,
                parent_id: item.parent_id,
                is_group: item.is_group,
                menu: item.menu,
                icon: item.icon,
                url_path: item.url_path.includes("http")
                  ? item.url_path + "?token=" + sso_token
                  : item.url_path,
                external: item.url_path.includes("http") ? true : false,
                child: [],
              });
            } else if (item.parent_id === 0) {
              container.push({
                menu_id: item.menu_id,
                parent_id: item.parent_id,
                is_group: item.is_group,
                menu: item.menu,
                icon: item.icon,
                external: item.url_path.includes("http") ? true : false,
                url_path: item.url_path.includes("http")
                  ? item.url_path + "?token=" + sso_token
                  : item.url_path,
              });
            }
          });

          // Level 2
          let indexing = -1;
          data.forEach((item, index) => {
            indexing = _.findIndex(container, function (menu) {
              return menu.menu_id === item.parent_id;
            });
            if (indexing >= 0) {
              container[indexing].child.push({
                menu_id: item.menu_id,
                parent_id: item.parent_id,
                is_group: item.is_group,
                menu: item.menu,
                icon: item.icon,
                url_path: item.url_path.includes("http")
                  ? item.url_path + "?token=" + sso_token
                  : item.url_path,
                external: item.url_path.includes("http") ? true : false,
                child: [],
              });
            }
          });

          // Level 3
          let subindexing = -1;
          data.forEach((item, index) => {
            container.forEach((itemsub, indexsub) => {
              subindexing = _.findIndex(itemsub.child, function (o) {
                return o.menu_id === item.parent_id;
              });
              if (subindexing >= 0) {
                container[indexsub].child[subindexing].child.push({
                  menu_id: item.menu_id,
                  parent_id: item.parent_id,
                  is_group: item.is_group,
                  menu: item.menu,
                  icon: item.icon,
                  url_path: item.url_path.includes("http")
                    ? item.url_path + "?token=" + sso_token
                    : item.url_path,
                  external: item.url_path.includes("http") ? true : false,
                  child: [],
                });
              }
            });
          });

          this.setState({ sidebarRoutes: container });
        }.bind(this),
        error: function (e) {
          console.log(e);
        },
      }
    );
  };

  renderArrow = (child) => {
    if (child > 0) {
      return <i className="fa fa-angle-left float-right"></i>;
    }
  };

  hasSUb = (child) => {
    return child > 0 ? "nav nav-treeview sidebar-submenu" : "nav nav-treeview";
  };

  handleRedirect = (e) => {
    let url = e.target.attributes.getNamedItem("data-url").value;
    if (url && url.length > 0) {
      window.open(url, "_blank");
    }
  };

  renderSubmenu = (submenu) => {
    if (submenu.child.length > 0) {
      return (
        <ul className="sidebar-submenu">
          {submenu.child.map((itemsub2, indexsub2) => {
            let hrefSub1 = itemsub2.external ? (
              <a
                href="javascript:void(0);"
                onClick={this.handleRedirect.bind(this)}
                data-url={itemsub2.url_path}
                target="_blank"
              >
                <i className={itemsub2.icon + " mr-1"}></i> {itemsub2.menu}
              </a>
            ) : (
              <Link to={itemsub2.url_path}>
                <i className={itemsub2.icon + " mr-1"}></i> {itemsub2.menu}
              </Link>
            );
            return <li key={indexsub2}>{hrefSub1}</li>;
          })}
        </ul>
      );
    }
  };

  render() {
    return (
      <div
        id="sidebar-section"
        className="sidebar-section"
        style={{ height: "100vh", overflow: "scroll" }}
      >
        <ul className="sidebar-menu">
          <li className="sidebar-header text-light">
            <h5>AR-MANAGEMENT</h5>
          </li>
          {/* <li className="sidebar-header text-light"><img src={ require('../../assets/img/aam-new-logo.png')} width={150} /></li> */}
          <li className="sidebar-header text-secondary row">
            <span className="col-md-3">
              <div
                style={{
                  background: "white",
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: "50%",
                  padding: "2px 10px 0px 10px",
                  fontSize: "40px",
                  height: "45px",
                  width: "45px"
                }}>
                <UserOutlined />
              </div>
              {/* <img
                src={require("../../assets/img/avatar5.png")}
                width={40}
                className="img-circle elevation-2"
                alt="User Profile"
              /> */}
            </span>
            <span className="col-md-9 my-auto text-truncate text-light">
              {this.state.user.realname} <br /> {this.state.user.role_name}
            </span>
          </li>
          <li className="sidebar-header">MAIN NAVIGATION</li>
          {this.state.sidebarRoutes.map((item, index) => {
            return (
              <li key={index}>
                <Link to={item.url_path}>
                  <i className={item.icon + " mr-1"}></i>{" "}
                  <span>{item.menu}</span>
                  {this.renderArrow(item.child.length)}
                </Link>
                <ul className="sidebar-submenu">
                  {item.child.map((itemsub, indexsub) => {
                    let hrefSub = itemsub.external ? (
                      <a
                        href="javascript:void(0);"
                        onClick={this.handleRedirect.bind(this)}
                        data-url={itemsub.url_path}
                        target="_blank"
                      >
                        <i className={itemsub.icon + " mr-1"}></i>{" "}
                        {itemsub.menu}
                      </a>
                    ) : (
                      <Link to={itemsub.url_path}>
                        <i className={itemsub.icon + " mr-1"}></i>{" "}
                        <span>{itemsub.menu}</span>
                        {this.renderArrow(itemsub.child.length)}
                      </Link>
                    );
                    return (
                      <li key={indexsub}>
                        {hrefSub}
                        {this.renderSubmenu(itemsub)}
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default Sidebar;
